import axios from "axios";
import config from "../../config.json";

export const handleApiError = (error, navigate) => {
  console.error("API Error:", error);
  if (error.response && error.response.status === 401) {
    console.log("Unauthorized request");
    const currentPath = typeof window !== "undefined" ? (window.location.pathname + window.location.search) : null;
    if (currentPath && currentPath !== "/" && currentPath !== "/login") {
      sessionStorage.setItem("redirectUrl", currentPath);
      localStorage.setItem("redirectUrl", currentPath);
      if (navigate) {
        navigate(`/login?redirect=${encodeURIComponent(currentPath)}`);
        return;
      }
    }
    if (navigate) navigate("/");
  }
};

export const getRouteById = async (
  effectiveRouteId,
  effectiveOrgId,
  navigate
) => {
  try {


    const resp = await axios.get(
      `${config.baseURL}/route/id?id=${effectiveRouteId}`,
      {
        params: { organizationId: effectiveOrgId },
        withCredentials: true,
      }
    );
    if (resp.status === 401) {
      console.log("Unauthorized request");
      navigate("/");
      return [];
    }
    console.log("Raw route API response:", resp.data);
    return [resp.data];
  } catch (error) {
    handleApiError(error, navigate);
    return [];
  }
};

export const fetchStopsForRoute = async (route, effectiveOrgId, navigate) => {
  const stops = [];
  for (const coordinate of route.routeCoordinates) {
    try {
      const stopsResponse = await axios.get(
        `${config.baseURL}/stop/organization/location`,
        {
          params: {
            organizationId: effectiveOrgId,
            longitude: coordinate.longitude,
            latitude: coordinate.latitude,
          },
          withCredentials: true,
        }
      );
      if (stopsResponse.status === 401) {
        console.log("Unauthorized request");
        navigate("/");
        return [];
      }
      if (stopsResponse.data) {
        stops.push(stopsResponse.data);
      }
    } catch (error) {
      handleApiError(error, navigate);
    }
  }
  return stops
    .flat()
    .filter(
      (stop, index, self) => index === self.findIndex((s) => s.id === stop.id)
    );
};

export const fetchStopDetails = async (stop, index, totalStops, deviceId) => {
  try {

    const response = await axios.post(
      `${config.baseURL}/distance/time/stop`,
      {
        vehicleId: deviceId,
        longitude: stop.longitude,
        latitude: stop.latitude,
        isExtreamPoint: index === 0 || index === totalStops - 1,
      },
      {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      }
    );

    console.log(`Stop ${stop.id} details:`, response.data);
    const distance = isFinite(response.data.distance)
      ? response.data.distance
      : null;
    const eta = isFinite(response.data.eta) ? response.data.eta : null;
    return { distance, eta };
  } catch (error) {
    console.error(`Error fetching details for stop ${stop.id}:`, error);
    return { distance: null, eta: null };
  }
};

export const fetchInitialData = async (
  effectiveRouteId,
  effectiveOrgId,
  effectiveDeviceId,
  setData,
  setLoadingStates,
  setVehicleIds,
  setStopDetails,
  navigate
) => {
  try {
    const routes = await getRouteById(
      effectiveRouteId,
      effectiveOrgId,
      navigate
    );
    console.log("Fetched routes:", routes);
    setData((prev) => ({ ...prev, routes }));
    setLoadingStates((prev) => ({ ...prev, routes: false }));

    if (routes.length > 0) {
      const vehicles = routes[0]?.vehicles || [];
      console.log("Fetched vehicles:", vehicles);
      setData((prev) => ({ ...prev, vehicles }));
      setVehicleIds(vehicles.map((v) => v.device_id));

      const stops = await fetchStopsForRoute(
        routes[0],
        effectiveOrgId,
        navigate
      );
      console.log("Fetched stops:", stops);
      setData((prev) => ({ ...prev, stops }));
      setLoadingStates((prev) => ({ ...prev, stops: false }));

      if (stops.length && effectiveDeviceId) {
        stops.forEach(async (stop, i) => {
          const details = await fetchStopDetails(
            stop,
            i,
            stops.length,
            effectiveDeviceId
          );
          setStopDetails((prev) => ({
            ...prev,
            [stop.id]: details,
          }));
        });
      }
    }
  } catch (error) {
    console.error("Error fetching initial data:", error);
    setLoadingStates((prev) => ({
      ...prev,
      routes: false,
      stops: false,
    }));
  }
};

export const getVehicleAndRouteDetails = async (vehicleId, routeId, orgId) => {
  try {
    const routeResponse = await axios.get(
      `${config.baseURL}/route/id?id=${routeId}`,
      {
        params: { organizationId: orgId },
        withCredentials: true,
      }
    );
    console.log(routeResponse, "routeResponse");

    let vehicle = routeResponse.data?.vehicles?.find(
      (v) => v.id === Number(vehicleId)
    );
    console.log("vehicle naveed", vehicle);

    // Fallback: If vehicle's driver relation is missing in the route response, fetch it directly
    if (vehicleId && (!vehicle || !vehicle.driver)) {
      try {
        const vehicleResp = await axios.get(`${config.baseURL}/vehicle/id`, {
          params: { vehicleId: vehicleId, organizationId: orgId },
          withCredentials: true,
        });
        const fetchedVehicle = vehicleResp.data?.vehicle || vehicleResp.data;
        if (fetchedVehicle) {
          vehicle = { ...vehicle, ...fetchedVehicle };
        }
      } catch (vehErr) {
        console.warn("[SOS] Fallback fetch for vehicle/driver failed:", vehErr);
      }
    }

    let transportInchargePhone = null;
    let transportInchargeEmail = null;
    let transportInchargeName = null;
    let adminPhone = null;

    // Check routeResponse.data.organization first
    const routeOrg = routeResponse.data?.organization || routeResponse.data?.Organization || {};
    console.log("[SOS Debug] Route Org Data:", routeOrg);

    if (orgId) {
      try {
        let orgData = routeOrg;
        if (!orgData.transportPhoneNumber) {
          try {
            const orgResponse = await axios.get(
              `${config.baseURL}/organization/${orgId}`,
              { withCredentials: true }
            );
            console.log("[SOS Debug] Org API Direct Response:", orgResponse.data);
            orgData =
              orgResponse.data?.organization ||
              orgResponse.data?.data ||
              orgResponse.data ||
              routeOrg;
          } catch (singleErr) {
            const orgResponse = await axios.get(
              `${config.baseURL}/organization`,
              { withCredentials: true }
            );
            const list = Array.isArray(orgResponse.data)
              ? orgResponse.data
              : orgResponse.data?.organizations || orgResponse.data?.data || [];
            orgData =
              list.find((o) => Number(o.id) === Number(orgId)) || routeOrg;
          }
        }

        console.log("[SOS Debug] Final Organization Data Object:", orgData);

        transportInchargePhone = orgData.transportPhoneNumber || null;
        transportInchargeEmail = orgData.transportInchargeEmail || null;
        transportInchargeName = orgData.transportInchargeName || null;
        adminPhone = orgData.contactPhone || null;
      } catch (orgErr) {
        console.error("Failed to fetch organization details:", orgErr);
      }
    }

    console.log("[SOS Debug] Extracted Transport In-Charge Phone:", transportInchargePhone);

    const driverName = vehicle?.driver
      ? `${vehicle.driver.first_name || ""}` + (vehicle.driver.last_name ? ` ${vehicle.driver.last_name}` : "")
      : vehicle?.driverName || null;

    const driverPhone = vehicle?.driver?.phone_number || vehicle?.driverPhone || null;
    const driverEmail = vehicle?.driver?.email || vehicle?.driverEmail || null;

    return {
      routeName: routeResponse.data?.name || "Unknown Route",
      vehicleName: vehicle?.name || "Unknown Vehicle",
      driverName: driverName,
      driverPhone: driverPhone,
      driverEmail: driverEmail,
      transportInchargePhone: transportInchargePhone,
      transportInchargeEmail: transportInchargeEmail,
      transportInchargeName: transportInchargeName,
      adminPhone: adminPhone,
    };
  } catch (error) {
    handleApiError(error);
    return {
      routeName: "Unknown Route",
      vehicleName: "Unknown Vehicle",
      driverName: null,
      driverPhone: null,
      driverEmail: null,
      transportInchargePhone: null,
      transportInchargeEmail: null,
      transportInchargeName: null,
      adminPhone: null,
    };
  }
};
